export default "__VITE_ASSET__Co5_xrzE__"